import React, { Component } from "react";
import classNames from "classnames";

const defaultProps = {
  onChange:                   () => {},
  onKeyUp:                    () => {},
  onKeyDown:                  () => {},
  onKeyPress:                 () => {},
  onFocus:                    () => {},
  name:                       'input',
  placeholder:                'Input value',
  refName:                    'input',
  label:                      '',
  tip:                        '',
  disabled:                   false,
  required:                   false,
  requiredSymbol:             false,
  pattern:                    undefined,
  actionInLabelText:          '',
  actionInLabelCallback:      () => {},
  addSpaceIfAdjacentHasError: false,
  dataTestId:                 '',
  step:                       null,
}

class TextInput extends Component {
  constructor(props) {
    super(props)

    this.handleChange  = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleKeyUp   = this.handleKeyUp.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleFocus  = this.handleFocus.bind(this);
  }

  get refName(){
    return this.props.refName;
  }

  getLabelClassName() {
    return classNames(
      'ds-input',
      this.props.labelClassName,
      { '_error': this.props.error },
    );
  }

  getClassName() {
    return classNames(
      this.props.className,
    );
  }

  getLabelRowClassName() {
    return classNames({ '_displayFlex _justifyContent-space-between': !!this.props.actionInLabelText });
  }

  renderError() {
    if (this.props.error) {
      let errorMessage = this.props.error.split('<br/>').map((message, index) => {
        return <p key={index}>{message}</p>
      })
      return <i data-test="text-input-error"> {errorMessage} </i>;
    }
    if (this.props.addSpaceIfAdjacentHasError) return <br />;
  }

  renderActionInLabel() {
    return (
      <a onClick={this.props.actionInLabelCallback}>{this.props.actionInLabelText}</a>
    );
  }

  renderLabelSection() {
    return (
      <span>
        {this.props.label}
        {this.renderRequiredSymbol()}
      </span>
    );
  }

  renderLabel() {
    if (!this.props.label) return;
    return(
      <div className={this.getLabelRowClassName()}>
        {this.renderLabelSection()}
        {this.renderActionInLabel()}
      </div>
    );
  }

  renderRequiredSymbol() {
    if (!this.props.requiredSymbol) return;
    return <i> *</i>;
  }

  handleChange(e) { this.props.onChange(e) }
  handleKeyDown(e) { this.props.onKeyDown(e) }
  handleKeyUp(e) { this.props.onKeyUp(e) }
  handleKeyPress(e) { this.props.onKeyPress(e) }
  handleFocus(e) { this.props.onFocus() }

  render() {
    return (
      <label className={this.getLabelClassName()}>
        {this.renderLabel()}
        {this.renderError()}
        <input
          data-test={this.props.name}
          name={this.props.name}
          type={this.props.type}
          value={this.props.value}
          id={this.props.id}
          className={this.getClassName()}
          onChange={this.handleChange}
          onKeyDown={this.handleKeyDown}
          onKeyUp={this.handleKeyUp}
          onKeyPress={this.handleKeyPress}
          placeholder={this.props.placeholder}
          ref={this.refName}
          disabled={this.props.disabled}
          required={this.props.required}
          max={this.props.max}
          min={this.props.min}
          step={this.props.step}
          maxLength={this.props.maxLength}
          minLength={this.props.minLength}
          pattern={this.props.pattern}
          onFocus={this.handleFocus}
          data-testid={this.props.dataTestId}
        />
        <small>{this.props.tip}</small>
      </label>
    );
  }
}

TextInput.defaultProps = defaultProps;
export default TextInput;



// WEBPACK FOOTER //
// ./src/features/shared/components/forms/TextInput.js